import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-export-finance-services',
    templateUrl: './export-finance-services.component.html',
    styleUrls: ['./export-finance-services.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExportFinanceServicesComponent implements OnInit {

	@Input() lists: any;
	@Input() filterArguments: any;
	@Input() currentProject?: any;
	@Output() closeView = new EventEmitter<string>();
	@Output() notify = new EventEmitter<string>();
	filterArgumentsCopy: any = [];
	loading: boolean = false;
	report_type: string = "services";

	submitForm() {
		this.notify.emit(this.filterArgumentsCopy);
	}
	close() {
		this.closeView.emit();
	}

	constructor() { }

	ngOnInit() {
		this.filterArgumentsCopy = Object.assign({}, this.filterArguments);
	}


}
